import { render, staticRenderFns } from "./QueueBranches.vue?vue&type=template&id=321a0590&"
import script from "./QueueBranches.vue?vue&type=script&lang=ts&"
export * from "./QueueBranches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports